import React, { Component } from 'react';
import Validation from './Validation';

class FormTarget extends Component {
  render() {
    const {
      coverImage,
      coverImageCrop,
      linkedComponent,
      redirectToExternalUrl,
      redirectUrl,
      launchSettingDialog,
      uploadIcon,
      formTitle,
      setInnerPlaceholders,
      formId,
    } = this.props;

    return (
      <div>
        <Validation
          coverImage={coverImage}
          coverImageCrop={coverImageCrop}
          linkedComponent={linkedComponent}
          redirectToExternalUrl={redirectToExternalUrl}
          redirectUrl={redirectUrl}
          launchSettingDialog={launchSettingDialog}
          uploadIcon={uploadIcon}
          formTitle={formTitle}
          setInnerPlaceholders={setInnerPlaceholders}
          formId={formId}
        />
      </div>
    );
  }
}

export default FormTarget;
